/**
 * Clears the error for each field that now has a value, so a red border
 * goes away as soon as the person fills it in. Format checks (email, phone,
 * GPA, zip, date) still run in their own change handlers after this.
 *
 * `aliases` maps a form key to the error key it shares, for example
 * `ethnicityOther` → `ethnicity`.
 */
function isFilled(value: unknown): boolean {
  if (Array.isArray(value)) return value.some(item => String(item ?? '').trim() !== '');
  if (typeof value === 'boolean') return value;
  return String(value ?? '').trim() !== '';
}

export default function clearFilledErrors<E extends object, T extends object>(
  current: E,
  partial: Partial<T>,
  aliases: Record<string, string | string[]> = {},
): E {
  let next = current as Record<string, string | undefined>;
  Object.entries(partial).forEach(([key, value]) => {
    if (!isFilled(value)) return;
    const keys = [key].concat(aliases[key] ?? []);
    keys.forEach(errorKey => {
      if (next[errorKey]) {
        if (next === (current as unknown)) next = { ...next };
        next[errorKey] = '';
      }
    });
  });
  return next as E;
}
